import React from 'react'
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage'
import { OKCover } from 'commonsComponents/OKCover'
import { translateText } from "../getTranslationsMyProfileUploadDocumentation";

const { formatText } = require('core/i18n').i18n;

export class UploadHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <OKCover size="large" section="pg" customClass="upload-document-cover">
                <OKHeaderSubPage
                    breadcrumbConfig={[
                        {
                            text: formatText('breadcrumb-documentation'),
                            url: '/myprofile/documentation'
                        },
                        {
                            text: translateText('titleHeader'),
                        }
                    ]}
                    finalTitle={translateText('titleHeader')}
                    overlap={false}
                >
                </OKHeaderSubPage>
            </OKCover>
        )
    }

}